import EnergyLabel from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import styles from "../../EnergyLabel.module.scss";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
import { ListItem as ListItemShared } from "../../../__shared__/ListItem/ListItem";
import cx from "classnames";

export type ListItemProps = {
  className?: string;
  handleClick?: () => void;
  isLegacy: boolean;
  rating: string;
};

export const ListItem = ({
  className,
  handleClick,
  isLegacy,
  rating,
}: ListItemProps) => {
  const classNames = cx(styles.energyLabelItem, className);

  return (
    <ListItemShared
      leadingIcon={
        <EnergyLabel
          rating={isLegacy ? undefined : rating}
          ratingLegacy={isLegacy ? rating : undefined}
          className={styles.energyLabelIcon}
        />
      }
      trailingIcon={
        handleClick ? (
          <ArrowRight data-testid={"energy-rating-arrow"} />
        ) : undefined
      }
      label={
        <>
          Energy rating: <span className={styles.rating}>{rating}</span>
        </>
      }
      onClick={handleClick}
      className={classNames}
    />
  );
};
